import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './reducer'
import * as state from './state'

export const chargeState = createFeatureSelector<state.State>('charge')

export const selectAllCharges = createSelector(chargeState, reducer.selectAll)

export const selectChargesLoaded = createSelector(chargeState, (state: state.State) => state.isLoaded)
export const selectChargeById = (id: string) => createSelector(reducer.selectEntities, (data) => data[id])

export const selectChargesByExtraId = (extraId: string) =>
  createSelector(selectAllCharges, (items) => {
    return items?.filter((t) => t.extra_id === extraId)
  })
